module.exports = __webpack_public_path__ + "img/level3addon_running_shadow.43523417.png";